import { type TimestampUTC } from '~/types/common';

import {
  entries,
  filter,
  fromEntries,
  map,
  pipe,
  toCamelCase,
} from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

/**
 * Extracts the timestamps of the process state changes from a delivery note.
 * @param deliveryNote - The delivery note to extract the process state change timestamps from.
 * @returns An object with the process state change timestamps.
 */
export const getProcessStateChangeTimestamps = (
  deliveryNote: DeliveryNoteAdmin,
): Record<string, TimestampUTC> => {
  const timestamps = pipe(
    entries(deliveryNote ?? {}),
    filter(([key]) => /^ts[A-Z]/.test(key)), // keys like tsReadyForOutput, tsArrived, etc.
    map(([key, value]) => [toCamelCase(key.replace(/^ts/, '')), value]),
    fromEntries,
  );

  return timestamps;
};
